import chalkboard from 'url:../../assets/cnn/fm/Chalkboard 10.png';
import skull from 'url:../../assets/cnn/fm/Skull 10.png';
import television48 from 'url:../../assets/cnn/fm/Television 48.png';
import vcr08 from 'url:../../assets/cnn/fm/VCR 08.png';
import candy_bag from 'url:../../assets/cnn/fm/Candy Bag 1.png';
import sticky1 from 'url:../../assets/cnn/fm/sticky1.png';
import dinosaur03 from 'url:../../assets/cnn/fm/Dinosaur Skull 03.png';
import polaroid2 from 'url:../../assets/cnn/fm/polaroid2.png';
import experiment6 from 'url:../../assets/cnn/fm/Science - Experiment 6.png';
import polaroid1 from 'url:../../assets/cnn/fm/polaroid1.png';
import outhouse from 'url:../../assets/cnn/fm/Outhouse 5.png';
import gas_pump from 'url:../../assets/cnn/fm/Gas Pump - Attendent.png';
import note_paper from 'url:../../assets/cnn/fm/Note Paper.png';
import flashlight20 from 'url:../../assets/cnn/fm/Flashlight 20.png';
import recipe from 'url:../../assets/cnn/fm/Recipe for Life.png';
import pencil_eraser from 'url:../../assets/cnn/fm/Pencil & Eraser 3.png';
import pipes from 'url:../../assets/cnn/fm/Pipes 3.png';
import gadget from 'url:../../assets/cnn/fm/Gadget 19.png';
import calendar from 'url:../../assets/cnn/fm/Wall Calendar 3.png';
import danger from 'url:../../assets/cnn/fm/Authorized Personnel 2.png';
import sticky3 from 'url:../../assets/cnn/fm/sticky3.png';
import bird_fish from 'url:../../assets/cnn/fm/Bird Eating Fish.png';
import student_thinking from 'url:../../assets/cnn/fm/Student Thinking.png';
import owl_in_tree from 'url:../../assets/cnn/fm/Owl in Tree 2.png';
import alligator from 'url:../../assets/cnn/fm/Alligator 04.png';
import books05 from 'url:../../assets/cnn/fm/Books 05.png';
import candle_cartoon from 'url:../../assets/cnn/fm/Candle Cartoon 1.png';
import globe_square from 'url:../../assets/cnn/fm/Globe - Square.png';
import flashlight11 from 'url:../../assets/cnn/fm/Flashlight 11.png';
import goo27 from 'url:../../assets/cnn/fm/Goo 27.png';
import casette6 from 'url:../../assets/cnn/fm/Video Cassette 06.png';
import books29 from 'url:../../assets/cnn/fm/Books 29.png';
import books10 from 'url:../../assets/cnn/fm/Books 10.png';
import book78 from 'url:../../assets/cnn/fm/Book 78.png';
import casette2 from 'url:../../assets/cnn/fm/Video Cassette 02.png';
import keys from 'url:../../assets/cnn/fm/Keys 08.png';
import read_book from 'url:../../assets/cnn/fm/Read a Book.png';
import student from 'url:../../assets/cnn/fm/Student at Computer 3.png';
import brain_cross from 'url:../../assets/cnn/fm/Brain - Cross Section 3.png';
import dinosaur10 from 'url:../../assets/cnn/fm/Dinosaur Skull 10.png';
import eye14 from 'url:../../assets/cnn/fm/Eye 14.png';
import eye11 from 'url:../../assets/cnn/fm/Eye 11.png';
import private_area from 'url:../../assets/cnn/fm/Private Area - Do Not Enter.png';
import test_pattern from 'url:../../assets/cnn/fm/Monitor & Test Pattern.png';
import flashlight19 from 'url:../../assets/cnn/fm/Flashlight 19.png';
import spaceship from 'url:../../assets/cnn/fm/Space Ship 41.png';
import poison from 'url:../../assets/cnn/fm/Poison 06.png';
import goo20 from 'url:../../assets/cnn/fm/Goo 20.png';
import telephone_poles from 'url:../../assets/cnn/fm/Telephone Poles 1.png';
import sneaker30 from 'url:../../assets/cnn/fm/Sneaker 30.png';
import experiment4 from 'url:../../assets/cnn/fm/Science - Experiment 4.png';
import computer from 'url:../../assets/cnn/fm/Computer Student.png';
import medicine_cabinet from 'url:../../assets/cnn/fm/Medicine Cabinet 5.png';
import bloodstain4 from 'url:../../assets/cnn/fm/Stroke 004.png';
import handprint from 'url:../../assets/cnn/fm/Stroke 030.png';
import soldier_alien from 'url:../../assets/cnn/fm/Soldier & Alien 1.png';
import alien_ufo from 'url:../../assets/cnn/fm/Down to Earth.png';
import doghouse from 'url:../../assets/cnn/fm/Dog in House 7.png';
import dog_with_owner from 'url:../../assets/cnn/fm/Dog with Owner 14.png';
import skeleton_half from 'url:../../assets/cnn/fm/Skeleton - Half.png';
import ghost44 from 'url:../../assets/cnn/fm/Ghost 44.png';
import medicine_dropper from 'url:../../assets/cnn/fm/Medicine Dropper 6.png';
import radio from 'url:../../assets/cnn/fm/Portable Radio 1.png';
import flyman from 'url:../../assets/cnn/fm/Experiment - Fly 1.png';
import question_teeth from 'url:../../assets/cnn/fm/Question Mark - Toothy.png';
import magnifying_glass from 'url:../../assets/cnn/fm/Magnifying Glass 4.png';
import mutant from 'url:../../assets/cnn/fm/Mutant Creature 053.png';
import iv_happy from 'url:../../assets/cnn/fm/IV - Happy.png';
import goo13 from 'url:../../assets/cnn/fm/Goo 13.png';
import jackhammer from 'url:../../assets/cnn/fm/Jackhammer Scene.png';
import lightbulb from 'url:../../assets/cnn/fm/Light Bulb - Cartoon 1.png';
import thumbtack1 from 'url:../../assets/cnn/fm/Thumbtack 1.png';
import thumbtack2 from 'url:../../assets/cnn/fm/Thumbtack 2.png';
import string_base from 'url:../../assets/cnn/fm/string-base.png';
import blue_note from 'url:../../assets/cnn/fm/Note - Blue.png';
import yellow_note from 'url:../../assets/cnn/fm/Note - Yellow.png';
import bll1 from 'url:../../assets/cnn/fm/blacklightletter1.png';
import bll2 from 'url:../../assets/cnn/fm/blacklightletter2.png';
import bll3 from 'url:../../assets/cnn/fm/blacklightletter3.png';
import bll4 from 'url:../../assets/cnn/fm/blacklightletter4.png';
import bll5 from 'url:../../assets/cnn/fm/blacklightletter5.png';
import bll6 from 'url:../../assets/cnn/fm/blacklightletter6.png';
import bll7 from 'url:../../assets/cnn/fm/blacklightletter7.png';
import static_bigtv from 'url:../../assets/cnn/fm/static-bigtv.gif';
import static_smalltv from 'url:../../assets/cnn/fm/static-smalltv.gif';
import static_computer from 'url:../../assets/cnn/fm/static-computer.gif';
import light_on from 'url:../../assets/cnn/fm/light-on.png';
import light_source from 'url:../../assets/cnn/fm/lightonsource-Dither_Boy.png';
import { CSSProperties, useState } from 'react';
import { CursorComponent } from '../../components/cursor/CursorComponent';
import { Plzma } from '../../components/cursor/plz/Plzma';

const STD_WIDTH : number = 2100;
const STD_HEIGHT : number = 1500;

export function CNNFM () {
    const width = 1920 / 2;
    const [bl, setBL] = useState(0);

    return <div className="page-basic bg-black v-box">
        <div className='height-64' />
        <div className="pos-rel mask-content" style={{width, height: width * STD_HEIGHT / STD_WIDTH}}>
            <FME src={chalkboard} left={-7.33} top={-12.60} width={124.43} />
            <FME src={skull} left={35.57} top={79.20} width={9.00} />
            <STC1 />
            <FME src={vcr08} left={7.62} top={86.73} width={31.05} style={{ transform: "rotateZ(-1.5deg)" }} />
            <FME src={blue_note} left={80.48} top={20.73} width={12.14} height={15.00} />
            <FME src={candy_bag} left={80.90} top={30.20} width={11.57} />
            <FME src={sticky1} left={74.00} top={10.47} width={15.86} height={21.40} style={{ transform: "rotateZ(10deg)" }} />
            <FME src={dinosaur03} left={68.43} top={23.47} width={5.76} style={{ transform: "rotateZ(-5deg)" }} />
            <FME src={polaroid2} left={63.05} top={1.53} width={14.52} height={23.07} />
            <FME src={experiment6} left={63.29} top={2.60} width={13.71} />
            <FME src={polaroid2} left={48.10} top={16.80} width={16.86} />
            <FME src={polaroid2} left={63.76} top={29.00} width={10.62} />
            <FME src={polaroid2} left={36.57} top={41.93} width={17.33} height={17.60} />
            <FME src={polaroid1} left={2.67} top={17.87} width={17.10} />
            <FME src={outhouse} left={64.43} top={30.87} width={10.19} />
            <FME src={gas_pump} left={6.38} top={22.33} width={7.71} />
            <FME src={note_paper} left={12.05} top={0.53} width={17.86} />
            <FL1 bl={bl} setBL={setBL} />
            <FME src={recipe} left={17.76} top={2.13} width={10.57} />
            <FME src={pencil_eraser} left={14.90} top={25.40} width={10.19} />
            <FME src={pipes} left={13.71} top={17.40} width={8.43} style={{ transform: "rotateZ(2deg)" }} />
            <FME src={gadget} left={15.71} top={5.13} width={5.90} />
            <FME src={calendar} left={7.43} top={6.67} width={7.95} />
            <FME src={danger} left={-4.00} top={-3.47} width={15.19} />
            <FME src={yellow_note} left={45.52} top={59.80} width={8.00} height={17.67} />
            <FME src={yellow_note} left={39.10} top={66.93} width={6.10} height={11.20} />
            <FME src={sticky3} left={23.62} top={19.27} width={17.05} style={{ transform: "rotateZ(-2.5deg)" }} />
            <FME src={bird_fish} left={25.87} top={27.53} width={11.05} style={{ transform: "rotateZ(20deg)" }} />
            <FME src={polaroid2} left={31.00} top={14.47} width={10.57} />
            <FME src={student_thinking} left={40.24} top={67.27} width={3.90} />
            <FME src={owl_in_tree} left={45.67} top={59.67} width={7.86} />
            <FME src={alligator} left={42.86} top={75.47} width={9.76} />
            <FME src={books05} left={-3.52} top={72.00} width={14.14} />
            <FME src={candle_cartoon} left={0.00} top={55.80} width={10.52} />
            <FME src={globe_square} left={3.52} top={91.07} width={10.81} />
            <FL2 bl={bl} setBL={setBL} />
            <FME src={goo27} left={3.33} top={91.40} width={5.62} />
            <FME src={casette6} left={50.71} top={85.80} width={10.43} />
            <FME src={books29} left={55.95} top={72.60} width={25.67} />
            <FME src={books10} left={70.19} top={66.20} width={36.90} />
            <FME src={book78} left={31.76} top={89.93} width={33.14} style={{ transform: "rotateZ(4.5deg)" }} />
            <FME src={casette2} left={40.24} top={87.80} width={14.81} style={{ transform: "scaleY(-1) rotateZ(-163deg)" }} />
            <FME src={keys} left={32.62} top={75.93} width={7.38} style={{ transform: "scaleY(-1) rotateZ(-125deg)" }} />
            <FME src={goo27} left={25.29} top={39.80} width={11.24} />
            <FME src={read_book} left={14.29} top={34.93} width={6.57} />
            <FME src={student} left={35.14} top={-1.20} width={12.76} />
            <FME src={brain_cross} left={54.90} top={3.47} width={6.29} />
            <FME src={dinosaur10} left={47.67} top={1.93} width={7.62} style={{ transform: "rotateZ(-12deg)" }} />
            <FME src={eye14} left={49.81} top={9.60} width={5.71} />
            <FME src={eye14} left={44.52} top={9.60} width={5.71} class="flip-h" />
            <FME src={eye11} left={92.29} top={41.40} width={7.52} style={{ transform: "rotateZ(-26deg)" }} />
            <FME src={private_area} left={91.14} top={2.00} width={6.67} />
            <STC2 />
            <FL3 bl={bl} setBL={setBL} />
            <FME src={spaceship} left={78.76} top={5.67} width={11.62} />
            <FME src={poison} left={80.05} top={20.07} width={8.43} />
            <FME src={goo20} left={82.00} top={36.27} width={5.33} style={{ transform: "rotateZ(31deg)" }} />
            <FME src={goo20} left={75.90} top={-3.60} width={7.19} style={{ transform: "scaleY(-1) rotateZ(-106deg)" }} />
            <FME src={telephone_poles} left={78.29} top={52.40} width={13.14} />
            <FME src={sneaker30} left={84.52} top={55.73} width={2.71} />
            <FME src={sneaker30} left={83.52} top={56.07} width={2.71} />
            <FME src={experiment4} left={78.29} top={64.07} width={8.43} />
            <STC3 />
            <FME src={medicine_cabinet} left={72.43} top={38.73} width={9.38} />
            <FME src={bloodstain4} left={76.76} top={39.73} width={5.10} />
            <FME src={handprint} left={75.48} top={47.93} width={2.62} />
            <FME src={soldier_alien} left={48.05} top={22.53} width={7.81} />
            <FME src={alien_ufo} left={48.71} top={20.07} width={14.71} />
            <FME src={doghouse} left={56.67} top={42.60} width={6.90} style={{ transform: "rotateZ(2.5deg)" }} />
            <FME src={dog_with_owner} left={53.24} top={47.47} width={9.00} />
            <FME src={skeleton_half} left={46.81} top={37.67} width={6.71} />
            <FME src={ghost44} left={37.19} top={37.73} width={5.14} />
            <FME src={medicine_dropper} left={42.95} top={29.87} width={5.43} />
            <FME src={radio} left={41.52} top={30.27} width={1.67} />
            <FME src={flyman} left={31.67} top={18.00} width={8.67} />
            <FME src={goo27} left={28.48} top={-4.73} width={11.52} />
            <FME src={question_teeth} left={68.38} top={56.13} width={8.00} />
            <FME src={magnifying_glass} left={55.95} top={91.80} width={10.67} style={{ transform: "scaleY(-1) rotateZ(-146deg)" }} />
            <FME src={mutant} left={68.05} top={91.20} width={4.38} />
            <FME src={iv_happy} left={79.81} top={69.00} width={5.33} style={{ transform: "rotateZ(-80deg)" }} />
            <FME src={goo13} left={56.81} top={66.07} width={13.95} />
            <FME src={jackhammer} left={39.05} top={48.47} width={10.14} />
            <FME src={lightbulb} left={87.57} top={40.07} width={4.86} />
            <FME src={thumbtack1} left={62.38} top={28.80} width={2.48} />
            <FME src={thumbtack1} left={58.95} top={15.73} width={2.48} style={{ transform: "scaleY(-1) rotateZ(-116.5deg)" }} />
            <FME src={thumbtack1} left={74.52} top={0.80} width={2.48} />
            <FME src={thumbtack1} left={86.00} top={19.80} width={2.48} />
            <FME src={thumbtack2} left={43.24} top={65.00} width={2.90} />
            <FME src={thumbtack2} left={29.24} top={23.67} width={2.90} />
            <FME src={thumbtack2} left={5.14} top={18.80} width={2.90} />
            <FME src={thumbtack2} left={38.95} top={12.47} width={2.90} />
            <FME src={thumbtack2} left={51.10} top={56.47} width={2.90} style={{ transform: "rotateZ(30deg)" }} />
            <FME src={thumbtack2} left={60.76} top={40.93} width={2.90} style={{ transform: "rotateZ(30deg)" }} />
            <FME src={string_base} left={25.67} top={5.20} width={69.10} noEvents={true} />
            <FME src={string_base} left={62.14} top={0.53} width={27.76} noEvents={true} style={{ transform: "scaleY(-1) rotateZ(162deg)" }} />
            <FME src={string_base} left={70.90} top={11.47} width={22.52} noEvents={true} style={{ transform: "scaleY(-1) rotateZ(-169deg)" }} />
            <FME src={string_base} left={59.86} top={28.47} width={22.52} noEvents={true} style={{ transform: "scaleY(-1) rotateZ(-165deg)" }} />
            <FME src={string_base} left={47.62} top={47.00} width={13.19} noEvents={true} style={{ transform: "scaleY(-1) rotateZ(153deg)" }} />
            <FME src={string_base} left={-22.10} top={25.20} width={30.14} noEvents={true} style={{ transform: "scaleY(-1) rotateZ(-172deg)" }} />
            <FME src={string_base} left={-20.62} top={26.63} width={30.14} noEvents={true} style={{ transform: "scaleY(-1) rotateZ(-167deg)" }} />
            <BL bl={bl} />
            <BL1 bl={bl} />
            <BL2 bl={bl} />
            <BL3 bl={bl} />
        </div>
    </div>
}

function STC1 () {
    return <Plzma
        startOn={true}
        onState={
            <>
                <FME src={television48} left={1.67} top={41.93} width={37.71} />
                <FME src={static_bigtv} left={10.14} top={47.13} width={25.95} height={29.93} />
            </>
        }
        offState={
            <FME src={television48} left={1.67} top={41.93} width={37.71} />
        }
    />
}

function STC2 () {
    return <Plzma
        startOn={true}
        onState={
            <>
                <FME src={test_pattern} left={90.10} top={13.33} width={8.71} />
                <FME src={static_smalltv} left={91.00} top={14.07} width={6.95} height={8.13} />
            </>
        }
        offState={
            <FME src={test_pattern} left={90.10} top={13.33} width={8.71} />
        }
    />
}

function STC3 () {
    return <Plzma
        startOn={true}
        onState={
            <>
                <FME src={computer} left={86.57} top={51.67} width={15.71} />
                <FME src={static_computer} left={93.81} top={52.80} width={4.71} height={7.87} />
            </>
        }
        offState={
            <FME src={computer} left={86.57} top={51.67} width={15.71} />
        }
    />
}

function FL1 (props: { bl: number, setBL : React.Dispatch<React.SetStateAction<number>>}) {
    return <Plzma
        startOn={false}
        onEnable={() => { props.setBL(props.bl + 1); }}
        onDisable={() => { props.setBL(props.bl - 1); }}
        onState={
            <FME src={flashlight20} left={20.81} top={8.07} width={9.38} style={{ transform: "rotateZ(34deg)" }} />
        }
        offState={
            <FME src={flashlight20} left={20.81} top={8.07} width={9.38} style={{ transform: "rotateZ(34deg)" }} />
        }
    />
}

function FL2 (props: { bl: number, setBL : React.Dispatch<React.SetStateAction<number>>}) {
    return <Plzma
        startOn={false}
        onEnable={() => { props.setBL(props.bl + 2); }}
        onDisable={() => { props.setBL(props.bl - 2); }}
        onState={
            <FME src={flashlight19} left={87.10} top={18.27} width={18.24} style={{ transform: "scaleY(-1) rotateZ(166deg)" }} />
        }
        offState={
            <FME src={flashlight19} left={87.10} top={18.27} width={18.24} style={{ transform: "scaleY(-1) rotateZ(166deg)" }} />
        }
    />
}

function FL3 (props: { bl: number, setBL : React.Dispatch<React.SetStateAction<number>>}) {
    return <Plzma
        startOn={false}
        onEnable={() => { props.setBL(props.bl + 4); }}
        onDisable={() => { props.setBL(props.bl - 4); }}
        onState={
            <FME src={flashlight11} left={12.10} top={92.27} width={18.29} />
        }
        offState={
            <FME src={flashlight11} left={12.10} top={92.27} width={18.29} />
        }
    />
}

function BL (props: {bl : number}) {
    return props.bl > 0 ? <>
        <div className='pos-abs bg-black no-events' style={{left:0, top:0, bottom:-1, right:0, filter: "opacity(.04)" }}> </div>
        <div className='pos-abs bg-blue no-events' style={{left:0, top:0, bottom:-1, right:0, filter: "opacity(.84)", mixBlendMode: "color-burn" }}> </div>
    </> : null;
}

function BL1 (props: {bl : number}) {
    return ((props.bl & 1) == 1) ? <>
        <FME src={bll4} left={41.52} top={38.00} width={1.14} height={2.07} style={{ transform: "rotateZ(15deg)" }} />
        <FME src={bll5} left={18.14} top={36.13} width={1.29} height={1.67} />
        <FME src={bll6} left={43.24} top={71.20} width={1.71} height={3.07} />
        <FME src={light_source} left={25.66} top={17.67} width={2.62} height={4.47} style={{ transform: "rotateZ(62deg)" }} />
        <FME src={light_on} left={22.77} top={18.43} width={10.00} height={15.87} style={{ transform: "rotateZ(-110deg)" }} />
    </> : null;
}

function BL2 (props: {bl : number}) {
    return ((props.bl & 2) == 2) ? <>
        <FME src={bll1} left={69.71} top={13.80} width={1.57} height={2.87} style={{ transform: "rotateZ(10deg)" }} />
        <FME src={bll2} left={70.33} top={34.93} width={2.52} height={4.53} />
        <FME src={bll7} left={52.20} top={19.53} width={3.43} height={6.20} style={{ transform: "rotateZ(-120deg)" }} />
        <FME src={light_source} left={89.81} top={26.7} width={4.38} height={7.53} />
        <FME src={light_on} left={77.05} top={15.60} width={15.90} height={25.20} />
    </> : null;
}

function BL3 (props: {bl : number}) {
    return ((props.bl & 4) == 4) ? <>
        <FME src={bll3} left={1.33} top={86.40} width={2.05} height={3.73} style={{ transform: "rotateZ(180deg)" }} />
        <FME src={light_source} left={15.87} top={93.67} width={1.95} height={7.53} style={{ transform: "rotateZ(-7deg)" }}/>
        <FME src={light_on} left={1.47} top={83.70} width={15.90} height={25.20} style={{ transform: "rotateZ(-7deg)" }} />
    </> : null;
}

function FME (props: {
    src: string,
    top: number,
    left: number,
    width: number,
    height ?: number,
    class ?: string,
    style ?: CSSProperties,
    noEvents ?: boolean
}) {
    const src = props.src;
    const t = props.top;
    const l = props.left;
    const w = props.width;
    let c = props.class !== undefined ? props.class : '';
    if (props.noEvents)
        c += ' no-events';
    return props.height !== null 
        ? <img src={src} className={'pos-abs ' + c} style={{
            top: t + "%", 
            left: l + "%", 
            width: w + "%",
            height: props.height + "%",
            ...props.style
        }} />
        : <img src={src} className={'pos-abs ' + c} style={{
            top: t + "%", 
            left: l + "%", 
            width: w + "%",
            ...props.style
        }} />
}

function FML (props: {
    chr: string,
    top: number,
    left: number
}) {
    const t = props.top;
    const l = props.left;

    return <div className='pos-abs text-32 text-white' style={{
        top: t + "%",
        left: l + "%",
        mixBlendMode: "hard-light"
    }}>
        <div className='pos-abs cnn-bl'>{props.chr}</div>
        <div className='pos-abs cnn-bl' style={{filter: "blur(4px)", mixBlendMode: "screen"}}>{props.chr}</div>
    </div>
}